export const dashboardUrl = '/dashboard';

export const figureLegalLinks = {
  blog: 'https://www.figure.com/blog',
  communications: 'https://www.figure.com/communications',
  contact: 'https://www.figure.com/contact',
  licenses: 'https://www.figure.com/licenses',
  privacy: 'https://www.figure.com/privacy',
  terms: 'https://www.figure.com/terms',
};
